export const RouterPath = {
    home: '',
    profile: 'profile',
    settings: 'settings',
    login: 'login',
    account: 'account',
    consultationRoom: 'consultation-room',
    passwordRecovery: 'password-recovery',
};
